import * as React from 'react'

import { ContractVersionsPageIncidenceRuleFragment } from 'generated/resources/graphql'
import { ObservableMap } from 'mobx'

import { observer } from 'mobx-react'

export interface ContractCues {
  hasCues: boolean
  incidenceRules: ContractVersionsPageIncidenceRuleFragment[]
  listOfFields: ObservableMap<unknown, unknown[]>
}

const Context = React.createContext<ContractCues | null>(null)

export const ContractCuesProvider = observer(
  ({ collection, children }: { collection: ContractCues; children: React.ReactNode }) => {
    return <Context.Provider value={collection}>{children}</Context.Provider>
  }
)

export const useContractCues = (): ContractCues => {
  const contractCues = React.useContext(Context)

  if (!contractCues) {
    throw new Error('useContractCues must be used within a ContractCuesProvider')
  }

  return contractCues
}
